import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-manage-promocode',
  templateUrl: './manage-promocode.component.html',
  styleUrls: ['./manage-promocode.component.scss']
})
export class ManagepromocodeComponent extends FeaturesBaseComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
